export default __webpack_public_path__ + "static/media/logoDigitaalOnthaal.75a53f70.png";